import React from 'react';
import { useTheme } from '@mui/material';
import logo from '../../assets/img/conneqt_logo.png';
import logoLight from '../../assets/img/conneQt_logo_light.png';
import styles from './logo.module.scss';

export function ConneqtLogo() {
  const theme = useTheme();
  return (
    <a
      target="_blank"
      href="https://www.hitiq.com/product/conneqt"
      rel="noopener noreferrer"
    >
      {theme.palette.mode === 'light' ? (
        <img src={logo} className={styles.logo} alt="Conneqt" />
      ) : (
        <img src={logoLight} className={styles.logo} alt="Conneqt" />
      )}
    </a>
  );
}
